import { render, staticRenderFns } from "./GroupDinnerComponent.vue?vue&type=template&id=489bd11e&scoped=true"
import script from "./GroupDinnerComponent.vue?vue&type=script&lang=js"
export * from "./GroupDinnerComponent.vue?vue&type=script&lang=js"
import style0 from "./GroupDinnerComponent.vue?vue&type=style&index=0&id=489bd11e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489bd11e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489bd11e')) {
      api.createRecord('489bd11e', component.options)
    } else {
      api.reload('489bd11e', component.options)
    }
    module.hot.accept("./GroupDinnerComponent.vue?vue&type=template&id=489bd11e&scoped=true", function () {
      api.rerender('489bd11e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/GroupDinnerComponent.vue"
export default component.exports